import React from 'react'
import Map from './Map'






export default function Home() {
  return (
 <>
 
 <Map/>

 
 
 </>
  )
}
